const baseURL = "https://metatrd.com.vn";
console.log('baseURL: ' + baseURL)
export { baseURL };

